// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pErXr","topic":"styles_topic__CoXo2","content":"styles_content__AS9xG"};